export default [
  {
    id: 'test',
    video: 'example.mp4', // Not implemented yet
    text: 'Just showing that the data is working. Usually a video would go here.'
  }
]
